const t = {
  global_fontFamily_sans: "var(--global-fontFamily-sans)",
  global_fontFamily_serif: "var(--global-fontFamily-serif)",
  global_fontFamily_monospace: "var(--global-fontFamily-monospace)",
  global_fontFamily_title: "var(--global-fontFamily-title)",
  global_palette_neutral_0: "var(--global-palette-neutral-0)",
  global_palette_neutral_50: "var(--global-palette-neutral-50)",
  global_palette_neutral_100: "var(--global-palette-neutral-100)",
  global_palette_neutral_200: "var(--global-palette-neutral-200)",
  global_palette_neutral_300: "var(--global-palette-neutral-300)",
  global_palette_neutral_400: "var(--global-palette-neutral-400)",
  global_palette_neutral_700: "var(--global-palette-neutral-700)",
  global_palette_neutral_800: "var(--global-palette-neutral-800)",
  global_palette_neutral_900: "var(--global-palette-neutral-900)",
  global_palette_neutral_1000: "var(--global-palette-neutral-1000)",
  global_palette_primary_100: "var(--global-palette-primary-100)",
  global_palette_primary_400: "var(--global-palette-primary-400)",
  global_palette_primary_600: "var(--global-palette-primary-600)",
  global_palette_primary_800: "var(--global-palette-primary-800)",
  global_palette_primary_900: "var(--global-palette-primary-900)",
  global_palette_secondary_100: "var(--global-palette-secondary-100)",
  global_palette_secondary_200: "var(--global-palette-secondary-200)",
  global_palette_secondary_300: "var(--global-palette-secondary-300)",
  global_palette_secondary_600: "var(--global-palette-secondary-600)",
  global_palette_secondary_800: "var(--global-palette-secondary-800)",
  global_palette_secondary_900: "var(--global-palette-secondary-900)",
  global_palette_alert_100: "var(--global-palette-alert-100)",
  global_palette_alert_300: "var(--global-palette-alert-300)",
  global_palette_alert_600: "var(--global-palette-alert-600)",
  global_palette_alert_800: "var(--global-palette-alert-800)",
  global_palette_alert_900: "var(--global-palette-alert-900)",
  global_palette_warning_100: "var(--global-palette-warning-100)",
  global_palette_warning_400: "var(--global-palette-warning-400)",
  global_palette_warning_600: "var(--global-palette-warning-600)",
  global_palette_warning_800: "var(--global-palette-warning-800)",
  global_palette_warning_900: "var(--global-palette-warning-900)",
  global_palette_danger_100: "var(--global-palette-danger-100)",
  global_palette_danger_300: "var(--global-palette-danger-300)",
  global_palette_danger_600: "var(--global-palette-danger-600)",
  global_palette_danger_800: "var(--global-palette-danger-800)",
  global_palette_danger_900: "var(--global-palette-danger-900)",
  global_palette_text_icon_primary: "var(--global-palette-text-icon-primary)",
  global_palette_text_icon_secondary: "var(--global-palette-text-icon-secondary)",
  global_palette_text_icon_disabled: "var(--global-palette-text-icon-disabled)",
  global_palette_text_icon_placeholder: "var(--global-palette-text-icon-placeholder)",
  global_palette_text_icon_filled: "var(--global-palette-text-icon-filled)",
  global_palette_text_icon_primary_light: "var(--global-palette-text-icon-primary-light)",
  global_palette_text_icon_secondary_light: "var(--global-palette-text-icon-secondary-light)",
  global_palette_text_icon_disabled_light: "var(--global-palette-text-icon-disabled-light)",
  global_palette_chart_purple_100: "var(--global-palette-chart-purple-100)",
  global_palette_chart_purple_400: "var(--global-palette-chart-purple-400)",
  global_palette_chart_purple_600: "var(--global-palette-chart-purple-600)",
  global_palette_chart_purple_800: "var(--global-palette-chart-purple-800)",
  global_palette_chart_red_100: "var(--global-palette-chart-red-100)",
  global_palette_chart_red_400: "var(--global-palette-chart-red-400)",
  global_palette_chart_red_600: "var(--global-palette-chart-red-600)",
  global_palette_chart_red_800: "var(--global-palette-chart-red-800)",
  global_palette_chart_red_medium_100: "var(--global-palette-chart-red-medium-100)",
  global_palette_chart_red_medium_400: "var(--global-palette-chart-red-medium-400)",
  global_palette_chart_red_medium_600: "var(--global-palette-chart-red-medium-600)",
  global_palette_chart_red_medium_800: "var(--global-palette-chart-red-medium-800)",
  global_palette_chart_orange_100: "var(--global-palette-chart-orange-100)",
  global_palette_chart_orange_400: "var(--global-palette-chart-orange-400)",
  global_palette_chart_orange_600: "var(--global-palette-chart-orange-600)",
  global_palette_chart_orange_800: "var(--global-palette-chart-orange-800)",
  global_palette_chart_yellow_100: "var(--global-palette-chart-yellow-100)",
  global_palette_chart_yellow_400: "var(--global-palette-chart-yellow-400)",
  global_palette_chart_yellow_600: "var(--global-palette-chart-yellow-600)",
  global_palette_chart_yellow_800: "var(--global-palette-chart-yellow-800)",
  global_palette_chart_blueberry_100: "var(--global-palette-chart-blueberry-100)",
  global_palette_chart_blueberry_400: "var(--global-palette-chart-blueberry-400)",
  global_palette_chart_blueberry_600: "var(--global-palette-chart-blueberry-600)",
  global_palette_chart_blueberry_800: "var(--global-palette-chart-blueberry-800)",
  global_palette_chart_blue_royal_100: "var(--global-palette-chart-blue-royal-100)",
  global_palette_chart_blue_royal_400: "var(--global-palette-chart-blue-royal-400)",
  global_palette_chart_blue_royal_600: "var(--global-palette-chart-blue-royal-600)",
  global_palette_chart_blue_royal_800: "var(--global-palette-chart-blue-royal-800)",
  palette_N0: "var(--palette-N0)",
  palette_N20: "var(--palette-N20)",
  palette_N50: "var(--palette-N50)",
  palette_N100: "var(--palette-N100)",
  palette_N200: "var(--palette-N200)",
  palette_N300: "var(--palette-N300)",
  palette_N400: "var(--palette-N400)",
  palette_N500: "var(--palette-N500)",
  palette_N600: "var(--palette-N600)",
  palette_N700: "var(--palette-N700)",
  palette_N800: "var(--palette-N800)",
  palette_N900: "var(--palette-N900)",
  palette_N1000: "var(--palette-N1000)",
  palette_P20: "var(--palette-P20)",
  palette_P50: "var(--palette-P50)",
  palette_P100: "var(--palette-P100)",
  palette_P200: "var(--palette-P200)",
  palette_P300: "var(--palette-P300)",
  palette_P400: "var(--palette-P400)",
  palette_P500: "var(--palette-P500)",
  palette_P600: "var(--palette-P600)",
  palette_P700: "var(--palette-P700)",
  palette_P800: "var(--palette-P800)",
  palette_P900: "var(--palette-P900)",
  palette_S20: "var(--palette-S20)",
  palette_S50: "var(--palette-S50)",
  palette_S100: "var(--palette-S100)",
  palette_S200: "var(--palette-S200)",
  palette_S300: "var(--palette-S300)",
  palette_S400: "var(--palette-S400)",
  palette_S500: "var(--palette-S500)",
  palette_S600: "var(--palette-S600)",
  palette_S700: "var(--palette-S700)",
  palette_S800: "var(--palette-S800)",
  palette_S900: "var(--palette-S900)",
  palette_A20: "var(--palette-A20)",
  palette_A50: "var(--palette-A50)",
  palette_A100: "var(--palette-A100)",
  palette_A200: "var(--palette-A200)",
  palette_A300: "var(--palette-A300)",
  palette_A400: "var(--palette-A400)",
  palette_A500: "var(--palette-A500)",
  palette_A600: "var(--palette-A600)",
  palette_A700: "var(--palette-A700)",
  palette_A800: "var(--palette-A800)",
  palette_A900: "var(--palette-A900)",
  palette_W20: "var(--palette-W20)",
  palette_W50: "var(--palette-W50)",
  palette_W100: "var(--palette-W100)",
  palette_W200: "var(--palette-W200)",
  palette_W300: "var(--palette-W300)",
  palette_W400: "var(--palette-W400)",
  palette_W500: "var(--palette-W500)",
  palette_W600: "var(--palette-W600)",
  palette_W700: "var(--palette-W700)",
  palette_W800: "var(--palette-W800)",
  palette_W900: "var(--palette-W900)",
  palette_D20: "var(--palette-D20)",
  palette_D50: "var(--palette-D50)",
  palette_D100: "var(--palette-D100)",
  palette_D200: "var(--palette-D200)",
  palette_D300: "var(--palette-D300)",
  palette_D400: "var(--palette-D400)",
  palette_D500: "var(--palette-D500)",
  palette_D600: "var(--palette-D600)",
  palette_D700: "var(--palette-D700)",
  palette_D800: "var(--palette-D800)",
  palette_D900: "var(--palette-D900)",
  palette_B20: "var(--palette-B20)",
  palette_B50: "var(--palette-B50)",
  palette_B100: "var(--palette-B100)",
  palette_B200: "var(--palette-B200)",
  palette_B300: "var(--palette-B300)",
  palette_B400: "var(--palette-B400)",
  palette_B500: "var(--palette-B500)",
  palette_B600: "var(--palette-B600)",
  palette_B700: "var(--palette-B700)",
  palette_B800: "var(--palette-B800)",
  palette_B900: "var(--palette-B900)",
  palette_R20: "var(--palette-R20)",
  palette_R50: "var(--palette-R50)",
  palette_R100: "var(--palette-R100)",
  palette_R200: "var(--palette-R200)",
  palette_R300: "var(--palette-R300)",
  palette_R400: "var(--palette-R400)",
  palette_R500: "var(--palette-R500)",
  palette_R600: "var(--palette-R600)",
  palette_R700: "var(--palette-R700)",
  palette_R800: "var(--palette-R800)",
  palette_R900: "var(--palette-R900)",
  palette_V20: "var(--palette-V20)",
  palette_V50: "var(--palette-V50)",
  palette_V100: "var(--palette-V100)",
  palette_V200: "var(--palette-V200)",
  palette_V300: "var(--palette-V300)",
  palette_V400: "var(--palette-V400)",
  palette_V500: "var(--palette-V500)",
  palette_V600: "var(--palette-V600)",
  palette_V700: "var(--palette-V700)",
  palette_V800: "var(--palette-V800)",
  palette_V900: "var(--palette-V900)",
  categorical_S600: "var(--categorical-S600)",
  categorical_W500: "var(--categorical-W500)",
  categorical_R500: "var(--categorical-R500)",
  categorical_A400: "var(--categorical-A400)",
  categorical_B500: "var(--categorical-B500)",
  categorical_D500: "var(--categorical-D500)",
  categorical_V500: "var(--categorical-V500)",
  categorical_P600: "var(--categorical-P600)",
  categorical_text_primary: "var(--categorical-text-primary)",
  categorical_text_secondary: "var(--categorical-text-secondary)",
  categorical_text_disabled: "var(--categorical-text-disabled)",
  palette_graph_V20: "var(--palette-graph-V20)",
  palette_graph_V50: "var(--palette-graph-V50)",
  palette_graph_V100: "var(--palette-graph-V100)",
  palette_graph_V200: "var(--palette-graph-V200)",
  palette_graph_V300: "var(--palette-graph-V300)",
  palette_graph_V400: "var(--palette-graph-V400)",
  palette_graph_V500: "var(--palette-graph-V500)",
  palette_graph_V600: "var(--palette-graph-V600)",
  palette_graph_V700: "var(--palette-graph-V700)",
  palette_graph_V800: "var(--palette-graph-V800)",
  palette_graph_V900: "var(--palette-graph-V900)",
  palette_graph_R20: "var(--palette-graph-R20)",
  palette_graph_R50: "var(--palette-graph-R50)",
  palette_graph_R100: "var(--palette-graph-R100)",
  palette_graph_R200: "var(--palette-graph-R200)",
  palette_graph_R300: "var(--palette-graph-R300)",
  palette_graph_R400: "var(--palette-graph-R400)",
  palette_graph_R500: "var(--palette-graph-R500)",
  palette_graph_R600: "var(--palette-graph-R600)",
  palette_graph_R700: "var(--palette-graph-R700)",
  palette_graph_R800: "var(--palette-graph-R800)",
  palette_graph_R900: "var(--palette-graph-R900)",
  palette_graph_D20: "var(--palette-graph-D20)",
  palette_graph_D50: "var(--palette-graph-D50)",
  palette_graph_D100: "var(--palette-graph-D100)",
  palette_graph_D200: "var(--palette-graph-D200)",
  palette_graph_D300: "var(--palette-graph-D300)",
  palette_graph_D400: "var(--palette-graph-D400)",
  palette_graph_D500: "var(--palette-graph-D500)",
  palette_graph_D600: "var(--palette-graph-D600)",
  palette_graph_D700: "var(--palette-graph-D700)",
  palette_graph_D800: "var(--palette-graph-D800)",
  palette_graph_D900: "var(--palette-graph-D900)",
  palette_graph_W20: "var(--palette-graph-W20)",
  palette_graph_W50: "var(--palette-graph-W50)",
  palette_graph_W100: "var(--palette-graph-W100)",
  palette_graph_W200: "var(--palette-graph-W200)",
  palette_graph_W300: "var(--palette-graph-W300)",
  palette_graph_W400: "var(--palette-graph-W400)",
  palette_graph_W500: "var(--palette-graph-W500)",
  palette_graph_W600: "var(--palette-graph-W600)",
  palette_graph_W700: "var(--palette-graph-W700)",
  palette_graph_W800: "var(--palette-graph-W800)",
  palette_graph_W900: "var(--palette-graph-W900)",
  palette_graph_A20: "var(--palette-graph-A20)",
  palette_graph_A50: "var(--palette-graph-A50)",
  palette_graph_A100: "var(--palette-graph-A100)",
  palette_graph_A200: "var(--palette-graph-A200)",
  palette_graph_A300: "var(--palette-graph-A300)",
  palette_graph_A400: "var(--palette-graph-A400)",
  palette_graph_A500: "var(--palette-graph-A500)",
  palette_graph_A600: "var(--palette-graph-A600)",
  palette_graph_A700: "var(--palette-graph-A700)",
  palette_graph_A800: "var(--palette-graph-A800)",
  palette_graph_A900: "var(--palette-graph-A900)",
  palette_graph_B20: "var(--palette-graph-B20)",
  palette_graph_B50: "var(--palette-graph-B50)",
  palette_graph_B100: "var(--palette-graph-B100)",
  palette_graph_B200: "var(--palette-graph-B200)",
  palette_graph_B300: "var(--palette-graph-B300)",
  palette_graph_B400: "var(--palette-graph-B400)",
  palette_graph_B500: "var(--palette-graph-B500)",
  palette_graph_B600: "var(--palette-graph-B600)",
  palette_graph_B700: "var(--palette-graph-B700)",
  palette_graph_B800: "var(--palette-graph-B800)",
  palette_graph_B900: "var(--palette-graph-B900)",
  palette_graph_S20: "var(--palette-graph-S20)",
  palette_graph_S50: "var(--palette-graph-S50)",
  palette_graph_S100: "var(--palette-graph-S100)",
  palette_graph_S200: "var(--palette-graph-S200)",
  palette_graph_S300: "var(--palette-graph-S300)",
  palette_graph_S400: "var(--palette-graph-S400)",
  palette_graph_S500: "var(--palette-graph-S500)",
  palette_graph_S600: "var(--palette-graph-S600)",
  palette_graph_S700: "var(--palette-graph-S700)",
  palette_graph_S800: "var(--palette-graph-S800)",
  palette_graph_S900: "var(--palette-graph-S900)",
  global_shadow_color: "var(--global-shadow-color)",
  global_scrollbar_color: "var(--global-scrollbar-color)",
  Table_headerBorderColor: "var(--Table-headerBorderColor)",
  Table_headerCellColor: "var(--Table-headerCellColor)",
  Table_footerBorderColor: "var(--Table-footerBorderColor)",
  Table_footerCellColor: "var(--Table-footerCellColor)",
  Table_rowBorderColor: "var(--Table-rowBorderColor)",
  Table_highlightedRowBackgroundColor: "var(--Table-highlightedRowBackgroundColor)",
  Table_highlightedProxyRowBackgroundColor: "var(--Table-highlightedProxyRowBackgroundColor)",
  FloatingContent_bgColor: "var(--FloatingContent-bgColor)",
  FloatingContent_color: "var(--FloatingContent-color)",
  FloatingContent_bandColor: "var(--FloatingContent-bandColor)",
  FloatingContent_closeIconColor: "var(--FloatingContent-closeIconColor)",
  Button_border_primary: "var(--Button-border-primary)",
  Button_border_primary_hover: "var(--Button-border-primary-hover)",
  Button_border_primary_active: "var(--Button-border-primary-active)",
  Button_border_primary_disabled: "var(--Button-border-primary-disabled)",
  Button_bg_primary: "var(--Button-bg-primary)",
  Button_bg_primary_hover: "var(--Button-bg-primary-hover)",
  Button_bg_primary_active: "var(--Button-bg-primary-active)",
  Button_bg_primary_disabled: "var(--Button-bg-primary-disabled)",
  Button_fg_primary: "var(--Button-fg-primary)",
  Button_fg_primary_disabled: "var(--Button-fg-primary-disabled)",
  Button_border_secondary: "var(--Button-border-secondary)",
  Button_border_secondary_disabled: "var(--Button-border-secondary-disabled)",
  Button_bg_secondary: "var(--Button-bg-secondary)",
  Button_bg_secondary_hover: "var(--Button-bg-secondary-hover)",
  Button_bg_secondary_active: "var(--Button-bg-secondary-active)",
  Button_bg_secondary_disabled: "var(--Button-bg-secondary-disabled)",
  Button_fg_secondary: "var(--Button-fg-secondary)",
  Button_fg_secondary_active: "var(--Button-fg-secondary-active)",
  Button_fg_secondary_disabled: "var(--Button-fg-secondary-disabled)",
  Button_border_neutral: "var(--Button-border-neutral)",
  Button_border_neutral_hover: "var(--Button-border-neutral-hover)",
  Button_border_neutral_active: "var(--Button-border-neutral-active)",
  Button_border_neutral_disabled: "var(--Button-border-neutral-disabled)",
  Button_bg_neutral: "var(--Button-bg-neutral)",
  Button_bg_neutral_hover: "var(--Button-bg-neutral-hover)",
  Button_bg_neutral_active: "var(--Button-bg-neutral-active)",
  Button_bg_neutral_disabled: "var(--Button-bg-neutral-disabled)",
  Button_fg_neutral: "var(--Button-fg-neutral)",
  Button_fg_neutral_disabled: "var(--Button-fg-neutral-disabled)",
  Button_border_neutralOutline: "var(--Button-border-neutralOutline)",
  Button_border_neutralOutline_hover: "var(--Button-border-neutralOutline-hover)",
  Button_border_neutralOutline_active: "var(--Button-border-neutralOutline-active)",
  Button_border_neutralOutline_disabled: "var(--Button-border-neutralOutline-disabled)",
  Button_bg_neutralOutline: "var(--Button-bg-neutralOutline)",
  Button_bg_neutralOutline_hover: "var(--Button-bg-neutralOutline-hover)",
  Button_bg_neutralOutline_active: "var(--Button-bg-neutralOutline-active)",
  Button_bg_neutralOutline_disabled: "var(--Button-bg-neutralOutline-disabled)",
  Button_fg_neutralOutline: "var(--Button-fg-neutralOutline)",
  Button_fg_neutralOutline_disabled: "var(--Button-fg-neutralOutline-disabled)",
  Button_bg_ghost: "var(--Button-bg-ghost)",
  Button_bg_ghost_hover: "var(--Button-bg-ghost-hover)",
  Button_bg_ghost_active: "var(--Button-bg-ghost-active)",
  Button_bg_ghost_disabled: "var(--Button-bg-ghost-disabled)",
  Button_fg_ghost: "var(--Button-fg-ghost)",
  Button_fg_ghost_disabled: "var(--Button-fg-ghost-disabled)",
  Button_border_info: "var(--Button-border-info)",
  Button_border_info_hover: "var(--Button-border-info-hover)",
  Button_border_info_active: "var(--Button-border-info-active)",
  Button_border_info_disabled: "var(--Button-border-info-disabled)",
  Button_bg_info: "var(--Button-bg-info)",
  Button_bg_info_hover: "var(--Button-bg-info-hover)",
  Button_bg_info_active: "var(--Button-bg-info-active)",
  Button_bg_info_disabled: "var(--Button-bg-info-disabled)",
  Button_fg_info: "var(--Button-fg-info)",
  Button_fg_info_disabled: "var(--Button-fg-info-disabled)",
  Button_border_infoOutline: "var(--Button-border-infoOutline)",
  Button_border_infoOutline_hover: "var(--Button-border-infoOutline-hover)",
  Button_border_infoOutline_active: "var(--Button-border-infoOutline-active)",
  Button_border_infoOutline_disabled: "var(--Button-border-infoOutline-disabled)",
  Button_bg_infoOutline: "var(--Button-bg-infoOutline)",
  Button_bg_infoOutline_hover: "var(--Button-bg-infoOutline-hover)",
  Button_bg_infoOutline_active: "var(--Button-bg-infoOutline-active)",
  Button_bg_infoOutline_disabled: "var(--Button-bg-infoOutline-disabled)",
  Button_fg_infoOutline: "var(--Button-fg-infoOutline)",
  Button_fg_infoOutline_active: "var(--Button-fg-infoOutline-active)",
  Button_fg_infoOutline_disabled: "var(--Button-fg-infoOutline-disabled)",
  Button_border_danger: "var(--Button-border-danger)",
  Button_border_danger_hover: "var(--Button-border-danger-hover)",
  Button_border_danger_active: "var(--Button-border-danger-active)",
  Button_border_danger_disabled: "var(--Button-border-danger-disabled)",
  Button_bg_danger: "var(--Button-bg-danger)",
  Button_bg_danger_hover: "var(--Button-bg-danger-hover)",
  Button_bg_danger_active: "var(--Button-bg-danger-active)",
  Button_bg_danger_disabled: "var(--Button-bg-danger-disabled)",
  Button_fg_danger: "var(--Button-fg-danger)",
  Button_fg_danger_disabled: "var(--Button-fg-danger-disabled)",
  Button_border_inverted: "var(--Button-border-inverted)",
  Button_bg_inverted: "var(--Button-bg-inverted)",
  Button_bg_inverted_hover: "var(--Button-bg-inverted-hover)",
  Button_bg_inverted_active: "var(--Button-bg-inverted-active)",
  Button_bg_inverted_disabled: "var(--Button-bg-inverted-disabled)",
  Button_fg_inverted: "var(--Button-fg-inverted)",
  Button_fg_inverted_disabled: "var(--Button-fg-inverted-disabled)",
  Tooltip_close_icon_fg: "var(--Tooltip-close-icon-fg)",
  Slider_fg_color: "var(--Slider-fg-color)",
  Slider_bar_bg_color: "var(--Slider-bar-bg-color)",
  Slider_bar_fg_color: "var(--Slider-bar-fg-color)",
  Slider_handle_border_color: "var(--Slider-handle-border-color)",
  Slider_handle_fill_color: "var(--Slider-handle-fill-color)",
  Slider_bar_step_fill_color: "var(--Slider-bar-step-fill-color)",
  Modal_overlay_bg: "var(--Modal-overlay-bg)",
  DialogBox_bg: "var(--DialogBox-bg)",
  DialogBox_footer_bg: "var(--DialogBox-footer-bg)",
  DialogBox_close_icon_fg: "var(--DialogBox-close-icon-fg)",
  ProgressBar_bg_color: "var(--ProgressBar-bg-color)",
  ProgressBar_fg_color: "var(--ProgressBar-fg-color)",
  ScrollWrapper_band_gradient_from: "var(--ScrollWrapper-band-gradient-from)",
  ScrollWrapper_band_gradient_to: "var(--ScrollWrapper-band-gradient-to)",
  MessageSeverity_info: "var(--MessageSeverity-info)",
  MessageSeverity_success: "var(--MessageSeverity-success)",
  MessageSeverity_warning: "var(--MessageSeverity-warning)",
  MessageSeverity_error: "var(--MessageSeverity-error)"
};
export {
  t as themeCSSVars
};
//# sourceMappingURL=index.js.map
